import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AppComponent } from '../app.component';
import { DataService } from '../_services/data.service';

import { TokenStorageService } from '../_services/token-storage.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

    private isLoggedIn: Boolean;

    constructor(
        private router: Router,
        private tokenStorageService: TokenStorageService,
        private dataService:DataService
    ) { this.isLoggedIn = false}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        this.isLoggedIn = !!this.tokenStorageService.getToken();
        if (route.data.roles && route.data.roles.indexOf(this.tokenStorageService.getRoles()) === -1) {
            // role not authorised so redirect to home page
            this.router.navigate(['/no-autorizado']);
            return false;
        }

        if (this.isLoggedIn) {
            return true;
        } else {
            this.router.navigate(['login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }
}